import { GridColumnType } from '@grid'
import { GridPreProcessEditCellProps } from '@mui/x-data-grid'
import { Validator, ValidatorResultType } from '@validators'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

dayjs.locale('ko')
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Seoul')

export const customerColumns: GridColumnType = {
	initRow: {
		profileColor: '',
		name: '',
		email: '',
		password: '',
		verifiedYn: 1,
		confirmEmailNewsYn: 0,
		createdAt: dayjs().format('YYYY-MM-DD HH:mm:ss'),
	},
	fieldToFocus: 'name',
	columns: [
		{
			field: 'profileColor',
			headerName: '아바타',
			display: 'flex',
			headerAlign: 'center',
			align: 'center',
			valueGetter: (value, row) => ({
				id: row.id ?? '',
				name: row.name ?? '',
				color: row.profileColor ?? '',
			}),
			sortable: false,
			filterable: false,
			editable: false,
		},
		{
			field: 'name',
			headerName: '이름',
			headerAlign: 'center',
			preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
				const res: ValidatorResultType = Validator.mainCustomer({
					name: params.props.value,
				})

				return {
					...params.props,
					error: !res.name.isValid,
					errorMessage: res.name.message ?? '',
				}
			},
			width: 150,
			editable: true,
		},
		{
			field: 'email',
			headerName: '이메일',
			headerAlign: 'center',
			width: 150,
			editable: true,
		},
		{
			field: 'confirmEmailNewsYn',
			headerName: '이메일 수신여부',
			type: 'boolean',
			headerAlign: 'center',
			valueFormatter: (value: number) => (value === 1 ? true : false),
			width: 160,
			editable: true,
		},
		{
			field: 'verifiedYn',
			headerName: '인증여부',
			type: 'boolean',
			headerAlign: 'center',
			valueFormatter: (value: number) => (value === 1 ? true : false),
			width: 70,
			editable: false,
		},
		{
			field: 'password',
			headerName: '패스워드',
			display: 'flex',
			headerAlign: 'center',
			align: 'center',
			width: 100,
			editable: true,
			valueGetter: (value, row) => ({
				...row,
			}),
		},
		{
			field: 'createdAt',
			headerName: '생성날짜',
			type: 'dateTime',
			headerAlign: 'center',
			valueFormatter: (value: string) =>
				value !== '' ? dayjs(value).tz().format('YYYY-MM-DD HH:mm:ss') : '',
			width: 200,
			editable: false,
		},
	],
}
